import axios from './axios'

class Coupon {
  /**
   * 获取优惠券
   * data {userId,type,statusList}
   * @param {number} userId 用户id
   * @param {number} type 用户id  1.平台通用券 2. 指定商品通用券 3.指定商品优惠券
   * @param {number} statusList []返回指定状态的优惠券 0. 生效 1.已使用 2.已锁定 3.已过期
   */
  getCouponApi(data, viewState) {
    return axios({
      url: `/Coupon/Api/Page`,
      method: 'post',
      data,
      headers: {
        'Ykt-ViewState': viewState
      }
    })
      .then(result => {
        return result
      })
      .catch(() => null)
  }
}

export default new Coupon()
